import React from 'react';
import Select, { NonceProvider, } from 'react-select';
export default function HitsPerPage({ hitsPerPageSettings, hitsPerPage }) {
    const { items, refine, } = hitsPerPage;
    const selectedItem = items.find(({ isRefined }) => isRefined) || {};
    const { className, classNamePrefix, classNames, inputId, styles, unstyled, menuIsOpen, components, nonce, cacheKey, } = hitsPerPageSettings;
    const props = {
        unstyled,
        menuIsOpen,
    };
    if (unstyled) {
        props.unstyled = true;
    }
    if (menuIsOpen) {
        props.menuIsOpen = true;
    }
    return (React.createElement(NonceProvider, { nonce: nonce || '', cacheKey: cacheKey || 'hits-per-page' },
        React.createElement(Select
        /* eslint-disable react/jsx-props-no-spreading */
        , Object.assign({}, props, { className: className, classNamePrefix: classNamePrefix || 'menu-select', classNames: classNames, inputId: inputId, styles: styles, isClearable: false, isSearchable: false, options: items, defaultValue: selectedItem, value: selectedItem, onChange: (option) => {
                const selectedOption = option ? option : null;
                const value = selectedOption ? selectedOption.value : '';
                refine(value);
            }, components: components }))));
}
